<template>
    <div id="about">
        <div class="about-title">
            <img src="../assets/logo.svg" alt="">
        </div>
        <div class="about-context">
            <div class="info">
                <li v-for="(item, i) in info" :key="i">{{item.el}}</li>
            </div>
        </div>
        <carousel
        :perPage="1"
        paginationActiveColor="#ed86a1"
        paginationColor="#999"
        :paginationPadding="4"
        :autoplay="true"
        :autoplayTimeout="3000"
        :loop="true"
        class="about-photos"
        >
            <slide class="photo-el"
            v-for="(item, i) in $store.state.photos" :key="i"
            :style="{backgroundImage: `url(${item.src})`}"
            >
            </slide>
        </carousel>
        <div class="credit" v-if="creditIndex == true">
            <button @click="creditIndex = !creditIndex">X</button>
            <div class="credit-container">
                <h1>전시를 준비하는 데 있어서 도움을 주신 모든 분들께 감사드립니다!</h1>
                <div class="credit-list">
                    <li v-for="(item, i) in creditList" :key="i">{{item}}</li>
                </div>
                <h1>졸업준비위원회</h1>
                <div class="credit-list">
                    <li v-for="(item, i) in creditList2" :key="i">{{item}}</li>
                </div>
            </div>
        </div>
        <div class="btns">
            <button @click="creditIndex = !creditIndex">도움주신분들</button>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import ChevronRight from '../assets/arrow_right.png';
import ChevronLeft from '../assets/arrow_left.png';

export default {
    components: {
        Carousel,
        Slide
    },
    computed: {
        navigationPrev() {
            const chevronLeft = ChevronLeft
            return `<img class="slide-btn btn-slide-prev" src="${ChevronLeft}"/>`
        },
        navigationNext() {
            const chevronRight = ChevronRight
            return `<img class="slide-btn btn-slide-next" src="${ChevronRight}"/>`
        },
    },
    data() {
        return {
            info : [
                { el: `2019.10.24(목)-27(일)` },
                { el: `10:00 am - 18:00 pm` },
                { el: `홍익대학로아트센터 B2F` },
            ],
            creditIndex: false,
            creditList: [ "최태선교수님","임춘택교수님","이윤정교수님","김주연교수님","이지아교수님","이상필교수님","서윤조교수님","정혜경교수님","손우현선배님","류현령선배님","박상욱선배님","이선창후배님","이준영후배님","최정윤후배님","인명열후배님","임정현후배님",],
            creditList2: [ "김도현","강다영","김기배","김용진","백서연","이상준","이해인","정미나"]
        }
    },
    methods: {

    }
    
}
</script>

<style scoped>
@media all and (max-width: 767px) {
    #about {
      margin: 88px auto;
      width: 96vw;
      min-height: 812px;
    }
    #about .about-title {
        display: none;
    }
    #about .about-title img {
        display: none;
    }
    #about .about-context {
        width: 96vw;
        margin: 40px auto;
    }
    #about .about-context .info {
        width: 96vw;
        margin: 0 auto;
        text-align: center;
    }
    #about .about-context .info li {
        text-align: center;
        list-style: none;
        margin: 16px 0;
        font-size: 0.9rem;
    }
    /* 전시 사진 슬라이드 */
    #about .about-photos {
        width: 96vw;
        height: 600px;
        margin: 0 auto;
    }
    #about .about-photos .photo-el {
        width: 96vw;
        height: 600px;
        margin: 0 auto;
        background-position: center;
        background-size: cover;
    }

    /* 이전, 다음 작품으로가는 버튼 */
    .btns {
        width: 92vw;
        margin: 48px auto;
    }
    .btns button{
        appearance: none;
        background: none;
        color: #ed86a1;
        border: 0;
        font-size: 0.9rem;
    }


    /* 크레딧 */
    .credit {
        width: 92vw;
        height: 86vh;
        padding: 3vh 2vw;
        background: #ed86a1 !important;
        color: #000 !important;
        position: fixed;
        top: 7vh;
        left: 2vw;
        z-index: 9999999999999;
        text-align: right;
        overflow-y: scroll;
    }
    .credit button {
        background: none;
        appearance: none;
        font-size: 1.2rem;
        border: 0;
    }
    .credit-container {
        width: 96%;
        margin: 0 auto;
        text-align: left;
    }
    .credit-container h1 {
        font-size: 2rem;
        font-weight: 900;
        margin: 40px 0;
        word-break: keep-all;
    }
    /* 리스트 */
    .credit-list {
        width: 98%;
    }
    .credit-list li{
        list-style: none;
        display: inline-block;
        margin: 10px;
        font-size: 0.9rem;
    }
}
@media all and (min-width: 768px) {
    #about {
      margin: 88px 2vw 0;
      width: 96vw;
    }
    #about .about-title {
        width: 96vw;
        margin: 32px auto;
        text-align: center;
    }
    #about .about-title img {
        width: 30vw;
    }
    #about .about-context {
        width: 96vw;
        margin: 48px auto;
    }
    #about .about-context .info {
        width: 96vw;
        margin: 0 auto;
        text-align: center;
    }
    #about .about-context .info li {
        text-align: center;
        list-style: none;
        margin: 0 24px;
        display: inline-block;
    }
    /* 전시 사진 슬라이드 */
    #about .about-photos {
        width: 70vw;
        height: 60vh;
        margin: 0 auto;
    }
    #about .about-photos .photo-el {
        width: 70vw;
        height: 60vh;
        margin: 0 auto;
        background-position: center;
        background-size: cover;
    }

    /* 크레딧버튼 */
    .btns {
        height: 32px;
        position: absolute;
        left: 2vw;
        bottom: 0;
        z-index: 9999;
    }
    .btns button{
        appearance: none;
        background: none;
        color: #ed86a1;
        border: 0;
        font-size: 0.9rem;
    }

    /* 크레딧 */
    .credit {
        width: 24vw;
        background: #ed86a1 !important;
        color: #000 !important;
        position: fixed;
        top: 8vh;
        left: 2vw;
        text-align: right;
        z-index: 9999999999999;
        overflow: hidden;
        box-shadow: 2px 4px 20px rgba(0, 0, 0, 0.5);
    }
    .credit-container {
        overflow: hidden;
    }
    .credit::-webkit-scrollbar, .credit-container::-webkit-scrollbar {
        display: none;
    }
    .credit button {
        margin: 0 0 32px;
        background: none;
        appearance: none;
        font-size: 2rem;
        border: 0;
    }
    .credit-container {
        padding: 1vh 2vw 3vh;
        text-align: left;
        overflow: hidden;
    }
    .credit-container h1 {
        font-size: 1.7rem;
        font-weight: 900;
        line-height: 2.3rem;
        word-break: keep-all;
    }
    /* 리스트 */
    .credit-list {
        width: 96%;
        margin: 16px 0 32px;
    }
    .credit-list li{
        list-style: none;
        display: inline-block;
        margin: 16px 8px 8px;
        font-size: 1.2rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AppAbout.vue